/* eslint-disable */
export {};

if (!Array.prototype.toSorted) {
  Object.defineProperty(Array.prototype, "toSorted", {
    value<T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
      return [...this].sort(compareFn);
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}

if (!Array.prototype.toReversed) {
  Object.defineProperty(Array.prototype, "toReversed", {
    value<T>(this: T[]): T[] {
      return [...this].reverse();
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}

if (!Array.prototype.toSpliced) {
  Object.defineProperty(Array.prototype, "toSpliced", {
    value<T>(
      this: T[],
      start: number,
      deleteCount?: number,
      ...items: T[]
    ): T[] {
      const copy = [...this];
      copy.splice(start, deleteCount ?? copy.length - start, ...items);
      return copy;
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}
